import { atom } from 'recoil';
import { isOpcDataFilledSelector } from '../selectors/isOpcDataFillerSelector';

export const isOpcDataFilledAtom = atom<boolean>({
    key: 'isOpcDataFilledAtom',
    default: isOpcDataFilledSelector
});
